import React from 'react';
import { createPortal } from 'react-dom';
import { useNavigate } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faBook,
  faCog,
} from '@fortawesome/free-solid-svg-icons';

import { useAuth } from '../../../../AuthContext';
import { redirectToLogin } from '../../../../utils/authRedirect';

import './SidebarMenuDropdown.css';

const apiUrl =
  process.env.REACT_APP_API_URL;

const SidebarMenuDropdown = ({
  visible,
  onMenuSelect,
  selectedMenu,
}) => {
  const navigate = useNavigate();
  const { setUser } = useAuth();

  const handleLogout = async () => {
    try {
      await fetch(`${apiUrl}/logout`, {
        method: 'POST',
        credentials: 'include',
      });

      localStorage.removeItem(
        'manuallyLoggedOut'
      );

      setUser(null);

      redirectToLogin();
    } catch (err) {
      console.warn(
        'Logout failed:',
        err
      );
    }
  };

  if (!visible) {
    return null;
  }

  return createPortal(
    <div className="sidebar-dropdown">
      <ul className="sidebar-dropdown-list">
        <li
          className={[
            'sidebar-dropdown-item',
            selectedMenu ===
            'CoursesInPlace'
              ? 'active'
              : '',
          ]
            .filter(Boolean)
            .join(' ')}
          onClick={() =>
            onMenuSelect?.(
              'CoursesInPlace'
            )
          }
        >
          <span className="sidebar-dropdown-icon">
            <FontAwesomeIcon
              icon={faBook}
            />
          </span>

          <span>Cursuri</span>
        </li>

        <hr className="sidebar-dropdown-divider" />

        <li
          className={[
            'sidebar-dropdown-item',
            selectedMenu === 'Setari'
              ? 'active'
              : '',
          ]
            .filter(Boolean)
            .join(' ')}
          onClick={() =>
            onMenuSelect?.('Setari')
          }
        >
          <span className="sidebar-dropdown-icon">
            <FontAwesomeIcon
              icon={faCog}
            />
          </span>

          <span>Setari</span>
        </li>

        <li
          className="sidebar-dropdown-item"
          onClick={() =>
            navigate('/ajutor')
          }
        >
          <span>Ajutor</span>
        </li>

        <li
          className="sidebar-dropdown-item"
          onClick={handleLogout}
        >
          <span>Deconectare</span>
        </li>
      </ul>
    </div>,
    document.body
  );
};

export default SidebarMenuDropdown;